import { AppIcons, BackrsFormField } from '@backrs_ui/common-ui';

import { ADULT_QUESTIONS } from './questions/questions.adult';
import { EDUCATOR_QUESTIONS } from './questions/questions.educator';
import { EMPLOYER_QUESTIONS } from './questions/questions.employer';
import { STUDENT_QUESTIONS } from './questions/questions.student';
import { StickerCardId } from '../Home/hooks/stickerCardMapping';

export const ONBOARDING_ON_COMPLETE_ACTIONS = {
  SUBMIT_USER_INFO: 'SUBMIT_USER_INFO',
  POST_PROFILE_OPTION_ANSWER: 'POST_PROFILE_OPTION_ANSWER',
  CONTINUE_WITHOUT_SUBMIT: 'CONTINUE_WITHOUT_SUBMIT',
} as const;

type OnboardingOnCompleteAction =
  (typeof ONBOARDING_ON_COMPLETE_ACTIONS)[keyof typeof ONBOARDING_ON_COMPLETE_ACTIONS];

type OnboardingOption = Readonly<{
  label: string;
  value: string;
  recommendation?: StickerCardId[];
}>;

export type OnboardingQuestion = Readonly<{
  title: string;
  subTitle: string;
  featuredIcon: AppIcons;
  onComplete: OnboardingOnCompleteAction;

  subAction?: {
    body: string;
    actionText: string;
    /**
     * Will navigate to the login page if 'LOGIN' is provided
     * Will skip question if 'SKIP' is provided
     */
    onClick: 'LOGIN' | 'SKIP';
  };
  question:
    | {
        type: 'CHECKBOX';
        options: OnboardingOption[];
        rules?: {
          required?: string;
        };

        post_type?: BackrsFormField['post_type'];

        profile_option_category_id?: string;
        profile_option_option_id?: string;
        profile_option_suboption_id?: string;
        profile_option_question_id?: string;
        profile_option_source?: string;
      }
    | {
        type: 'RADIO';
        options: OnboardingOption[];
        rules?: {
          required?: string;
        };

        post_type?: BackrsFormField['post_type'];

        profile_option_category_id?: string;
        profile_option_option_id?: string;
        profile_option_suboption_id?: string;
        profile_option_question_id?: string;
        profile_option_source?: string;
      }
    | {
        type: 'FORM';
        fields: BackrsFormField[];
      };
}>;

export const ONBOARDING_CONFIGS = {
  student: STUDENT_QUESTIONS,
  adult: ADULT_QUESTIONS,
  educator: EDUCATOR_QUESTIONS,
  employer: EMPLOYER_QUESTIONS,
} as const;

export type OnboardingFlow = keyof typeof ONBOARDING_CONFIGS;
